export const REGISTRATION_NEW_QUERY_KEY = ['registration', 'new'] as const;
export const REGISTRATION_QUERY_KEY = ['registration'] as const;
